import DOMPurify from 'dompurify';

type AcuityParameters = {
    src: string | null;
    height: number | null;
};

export const extractor = (code: string) => {
    const extracted: AcuityParameters = {
        src: null,
        height: null
    };

    const sanitized = DOMPurify.sanitize(code, {
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['allow', 'frameborder', 'src', 'height', 'width']
    });

    if (sanitized) {
        const parser = new DOMParser();

        const form = parser.parseFromString(sanitized, 'text/html');
        const iframe = form.querySelector('iframe');

        if (iframe) {
            const src = iframe.getAttribute('src') || '';

            const [, tail] = src.split('acuityscheduling.com/');

            if (tail) {
                // avoid hacky links
                extracted.src = `https://app.acuityscheduling.com/${tail}`;
            }

            const height = parseInt(iframe.getAttribute('height') || '') || '';

            if (height) {
                extracted.height = height;
            }
        }
    }

    return extracted;
};

export const validator = async (code: string) => {
    if (!code) {
        return false;
    }

    const { src, height } = extractor(code);

    return Boolean(src && height);
};

export default { validator, extractor };
